// removed by extract-text-webpack-plugin
module.exports = {"btn":"src-components-Page----ECommerce-module---btn---2VmR7","btn-primary":"src-components-Page----ECommerce-module---btn-primary---3zYQq","btn-wrap-pre":"src-components-Page----ECommerce-module---btn-wrap-pre---pW3XE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/ECommerce.module.scss
// module id = 423
// module chunks = 118514840243029